<template>
  <div id="logo" class="col-4">
    <img alt="denisecko" src="@/assets/SmallDedeLogo_black.svg" height="50px" />
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>
